"use strict";
/**
 * AUTOGENERATED
 *
 * DO NOT MODIFY
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.HU = void 0;
exports.HU = {
    numericCode: '348',
    alpha2Code: 'HU',
    alpha3Code: 'HUN',
    englishName: {
        short: 'Hungary',
        full: 'Hungary',
    },
    names: {
        full: {
            en: 'Hungary',
            fr: 'Hongrie (la)',
            hu: 'Magyarország',
        },
        short: {
            en: 'Hungary',
            fr: 'Hongrie (la)',
            hu: 'Magyarország',
        },
    },
    languages: [
        {
            languageAlpha2Code: 'en',
            languageAlpha3Code: 'eng',
            isAdministrative: false,
        },
        {
            languageAlpha2Code: 'fr',
            languageAlpha3Code: 'fra',
            isAdministrative: false,
        },
        {
            languageAlpha2Code: 'hu',
            languageAlpha3Code: 'hun',
            isAdministrative: true,
        },
    ],
    subdivisions: {
        'HU-BA': {
            numericCode: '348',
            code: 'HU-BA',
            category: {
                id: '204',
                names: {
                    en: {
                        singular: 'county',
                        plural: 'counties',
                    },
                    fr: {
                        singular: 'comitat',
                        plural: '',
                    },
                    hu: {
                        singular: 'megye',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                hu: 'Baranya',
            },
        },
        'HU-BE': {
            numericCode: '348',
            code: 'HU-BE',
            category: {
                id: '204',
                names: {
                    en: {
                        singular: 'county',
                        plural: 'counties',
                    },
                    fr: {
                        singular: 'comitat',
                        plural: '',
                    },
                    hu: {
                        singular: 'megye',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                hu: 'Békés',
            },
        },
        'HU-BK': {
            numericCode: '348',
            code: 'HU-BK',
            category: {
                id: '204',
                names: {
                    en: {
                        singular: 'county',
                        plural: 'counties',
                    },
                    fr: {
                        singular: 'comitat',
                        plural: '',
                    },
                    hu: {
                        singular: 'megye',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                hu: 'Bács-Kiskun',
            },
        },
        'HU-BZ': {
            numericCode: '348',
            code: 'HU-BZ',
            category: {
                id: '204',
                names: {
                    en: {
                        singular: 'county',
                        plural: 'counties',
                    },
                    fr: {
                        singular: 'comitat',
                        plural: '',
                    },
                    hu: {
                        singular: 'megye',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                hu: 'Borsod-Abaúj-Zemplén',
            },
        },
        'HU-CS': {
            numericCode: '348',
            code: 'HU-CS',
            category: {
                id: '204',
                names: {
                    en: {
                        singular: 'county',
                        plural: 'counties',
                    },
                    fr: {
                        singular: 'comitat',
                        plural: '',
                    },
                    hu: {
                        singular: 'megye',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                hu: 'Csongrád-Csanád',
            },
        },
        'HU-FE': {
            numericCode: '348',
            code: 'HU-FE',
            category: {
                id: '204',
                names: {
                    en: {
                        singular: 'county',
                        plural: 'counties',
                    },
                    fr: {
                        singular: 'comitat',
                        plural: '',
                    },
                    hu: {
                        singular: 'megye',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                hu: 'Fejér',
            },
        },
        'HU-GS': {
            numericCode: '348',
            code: 'HU-GS',
            category: {
                id: '204',
                names: {
                    en: {
                        singular: 'county',
                        plural: 'counties',
                    },
                    fr: {
                        singular: 'comitat',
                        plural: '',
                    },
                    hu: {
                        singular: 'megye',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                hu: 'Győr-Moson-Sopron',
            },
        },
        'HU-HB': {
            numericCode: '348',
            code: 'HU-HB',
            category: {
                id: '204',
                names: {
                    en: {
                        singular: 'county',
                        plural: 'counties',
                    },
                    fr: {
                        singular: 'comitat',
                        plural: '',
                    },
                    hu: {
                        singular: 'megye',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                hu: 'Hajdú-Bihar',
            },
        },
        'HU-HE': {
            numericCode: '348',
            code: 'HU-HE',
            category: {
                id: '204',
                names: {
                    en: {
                        singular: 'county',
                        plural: 'counties',
                    },
                    fr: {
                        singular: 'comitat',
                        plural: '',
                    },
                    hu: {
                        singular: 'megye',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                hu: 'Heves',
            },
        },
        'HU-JN': {
            numericCode: '348',
            code: 'HU-JN',
            category: {
                id: '204',
                names: {
                    en: {
                        singular: 'county',
                        plural: 'counties',
                    },
                    fr: {
                        singular: 'comitat',
                        plural: '',
                    },
                    hu: {
                        singular: 'megye',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                hu: 'Jász-Nagykun-Szolnok',
            },
        },
        'HU-KE': {
            numericCode: '348',
            code: 'HU-KE',
            category: {
                id: '204',
                names: {
                    en: {
                        singular: 'county',
                        plural: 'counties',
                    },
                    fr: {
                        singular: 'comitat',
                        plural: '',
                    },
                    hu: {
                        singular: 'megye',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                hu: 'Komárom-Esztergom',
            },
        },
        'HU-NO': {
            numericCode: '348',
            code: 'HU-NO',
            category: {
                id: '204',
                names: {
                    en: {
                        singular: 'county',
                        plural: 'counties',
                    },
                    fr: {
                        singular: 'comitat',
                        plural: '',
                    },
                    hu: {
                        singular: 'megye',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                hu: 'Nógrád',
            },
        },
        'HU-PE': {
            numericCode: '348',
            code: 'HU-PE',
            category: {
                id: '204',
                names: {
                    en: {
                        singular: 'county',
                        plural: 'counties',
                    },
                    fr: {
                        singular: 'comitat',
                        plural: '',
                    },
                    hu: {
                        singular: 'megye',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                hu: 'Pest',
            },
        },
        'HU-SO': {
            numericCode: '348',
            code: 'HU-SO',
            category: {
                id: '204',
                names: {
                    en: {
                        singular: 'county',
                        plural: 'counties',
                    },
                    fr: {
                        singular: 'comitat',
                        plural: '',
                    },
                    hu: {
                        singular: 'megye',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                hu: 'Somogy',
            },
        },
        'HU-SZ': {
            numericCode: '348',
            code: 'HU-SZ',
            category: {
                id: '204',
                names: {
                    en: {
                        singular: 'county',
                        plural: 'counties',
                    },
                    fr: {
                        singular: 'comitat',
                        plural: '',
                    },
                    hu: {
                        singular: 'megye',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                hu: 'Szabolcs-Szatmár-Bereg',
            },
        },
        'HU-TO': {
            numericCode: '348',
            code: 'HU-TO',
            category: {
                id: '204',
                names: {
                    en: {
                        singular: 'county',
                        plural: 'counties',
                    },
                    fr: {
                        singular: 'comitat',
                        plural: '',
                    },
                    hu: {
                        singular: 'megye',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                hu: 'Tolna',
            },
        },
        'HU-VA': {
            numericCode: '348',
            code: 'HU-VA',
            category: {
                id: '204',
                names: {
                    en: {
                        singular: 'county',
                        plural: 'counties',
                    },
                    fr: {
                        singular: 'comitat',
                        plural: '',
                    },
                    hu: {
                        singular: 'megye',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                hu: 'Vas',
            },
        },
        'HU-VE': {
            numericCode: '348',
            code: 'HU-VE',
            category: {
                id: '204',
                names: {
                    en: {
                        singular: 'county',
                        plural: 'counties',
                    },
                    fr: {
                        singular: 'comitat',
                        plural: '',
                    },
                    hu: {
                        singular: 'megye',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                hu: 'Veszprém',
            },
        },
        'HU-ZA': {
            numericCode: '348',
            code: 'HU-ZA',
            category: {
                id: '204',
                names: {
                    en: {
                        singular: 'county',
                        plural: 'counties',
                    },
                    fr: {
                        singular: 'comitat',
                        plural: '',
                    },
                    hu: {
                        singular: 'megye',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                hu: 'Zala',
            },
        },
        'HU-BC': {
            numericCode: '348',
            code: 'HU-BC',
            category: {
                id: '245',
                names: {
                    en: {
                        singular: 'city with county rights',
                        plural: 'cities of county right',
                    },
                    fr: {
                        singular: 'ville ayant un rang de comitat',
                        plural: '',
                    },
                    hu: {
                        singular: 'megyei jogú város',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                hu: 'Békéscsaba',
            },
        },
        'HU-DE': {
            numericCode: '348',
            code: 'HU-DE',
            category: {
                id: '245',
                names: {
                    en: {
                        singular: 'city with county rights',
                        plural: 'cities of county right',
                    },
                    fr: {
                        singular: 'ville ayant un rang de comitat',
                        plural: '',
                    },
                    hu: {
                        singular: 'megyei jogú város',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                hu: 'Debrecen',
            },
        },
        'HU-DU': {
            numericCode: '348',
            code: 'HU-DU',
            category: {
                id: '245',
                names: {
                    en: {
                        singular: 'city with county rights',
                        plural: 'cities of county right',
                    },
                    fr: {
                        singular: 'ville ayant un rang de comitat',
                        plural: '',
                    },
                    hu: {
                        singular: 'megyei jogú város',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                hu: 'Dunaújváros',
            },
        },
        'HU-EG': {
            numericCode: '348',
            code: 'HU-EG',
            category: {
                id: '245',
                names: {
                    en: {
                        singular: 'city with county rights',
                        plural: 'cities of county right',
                    },
                    fr: {
                        singular: 'ville ayant un rang de comitat',
                        plural: '',
                    },
                    hu: {
                        singular: 'megyei jogú város',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                hu: 'Eger',
            },
        },
        'HU-ER': {
            numericCode: '348',
            code: 'HU-ER',
            category: {
                id: '245',
                names: {
                    en: {
                        singular: 'city with county rights',
                        plural: 'cities of county right',
                    },
                    fr: {
                        singular: 'ville ayant un rang de comitat',
                        plural: '',
                    },
                    hu: {
                        singular: 'megyei jogú város',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                hu: 'Érd',
            },
        },
        'HU-GY': {
            numericCode: '348',
            code: 'HU-GY',
            category: {
                id: '245',
                names: {
                    en: {
                        singular: 'city with county rights',
                        plural: 'cities of county right',
                    },
                    fr: {
                        singular: 'ville ayant un rang de comitat',
                        plural: '',
                    },
                    hu: {
                        singular: 'megyei jogú város',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                hu: 'Győr',
            },
        },
        'HU-HV': {
            numericCode: '348',
            code: 'HU-HV',
            category: {
                id: '245',
                names: {
                    en: {
                        singular: 'city with county rights',
                        plural: 'cities of county right',
                    },
                    fr: {
                        singular: 'ville ayant un rang de comitat',
                        plural: '',
                    },
                    hu: {
                        singular: 'megyei jogú város',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                hu: 'Hódmezővásárhely',
            },
        },
        'HU-KM': {
            numericCode: '348',
            code: 'HU-KM',
            category: {
                id: '245',
                names: {
                    en: {
                        singular: 'city with county rights',
                        plural: 'cities of county right',
                    },
                    fr: {
                        singular: 'ville ayant un rang de comitat',
                        plural: '',
                    },
                    hu: {
                        singular: 'megyei jogú város',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                hu: 'Kecskemét',
            },
        },
        'HU-KV': {
            numericCode: '348',
            code: 'HU-KV',
            category: {
                id: '245',
                names: {
                    en: {
                        singular: 'city with county rights',
                        plural: 'cities of county right',
                    },
                    fr: {
                        singular: 'ville ayant un rang de comitat',
                        plural: '',
                    },
                    hu: {
                        singular: 'megyei jogú város',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                hu: 'Kaposvár',
            },
        },
        'HU-MI': {
            numericCode: '348',
            code: 'HU-MI',
            category: {
                id: '245',
                names: {
                    en: {
                        singular: 'city with county rights',
                        plural: 'cities of county right',
                    },
                    fr: {
                        singular: 'ville ayant un rang de comitat',
                        plural: '',
                    },
                    hu: {
                        singular: 'megyei jogú város',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                hu: 'Miskolc',
            },
        },
        'HU-NK': {
            numericCode: '348',
            code: 'HU-NK',
            category: {
                id: '245',
                names: {
                    en: {
                        singular: 'city with county rights',
                        plural: 'cities of county right',
                    },
                    fr: {
                        singular: 'ville ayant un rang de comitat',
                        plural: '',
                    },
                    hu: {
                        singular: 'megyei jogú város',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                hu: 'Nagykanizsa',
            },
        },
        'HU-NY': {
            numericCode: '348',
            code: 'HU-NY',
            category: {
                id: '245',
                names: {
                    en: {
                        singular: 'city with county rights',
                        plural: 'cities of county right',
                    },
                    fr: {
                        singular: 'ville ayant un rang de comitat',
                        plural: '',
                    },
                    hu: {
                        singular: 'megyei jogú város',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                hu: 'Nyíregyháza',
            },
        },
        'HU-PS': {
            numericCode: '348',
            code: 'HU-PS',
            category: {
                id: '245',
                names: {
                    en: {
                        singular: 'city with county rights',
                        plural: 'cities of county right',
                    },
                    fr: {
                        singular: 'ville ayant un rang de comitat',
                        plural: '',
                    },
                    hu: {
                        singular: 'megyei jogú város',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                hu: 'Pécs',
            },
        },
        'HU-SD': {
            numericCode: '348',
            code: 'HU-SD',
            category: {
                id: '245',
                names: {
                    en: {
                        singular: 'city with county rights',
                        plural: 'cities of county right',
                    },
                    fr: {
                        singular: 'ville ayant un rang de comitat',
                        plural: '',
                    },
                    hu: {
                        singular: 'megyei jogú város',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                hu: 'Szeged',
            },
        },
        'HU-SF': {
            numericCode: '348',
            code: 'HU-SF',
            category: {
                id: '245',
                names: {
                    en: {
                        singular: 'city with county rights',
                        plural: 'cities of county right',
                    },
                    fr: {
                        singular: 'ville ayant un rang de comitat',
                        plural: '',
                    },
                    hu: {
                        singular: 'megyei jogú város',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                hu: 'Székesfehérvár',
            },
        },
        'HU-SH': {
            numericCode: '348',
            code: 'HU-SH',
            category: {
                id: '245',
                names: {
                    en: {
                        singular: 'city with county rights',
                        plural: 'cities of county right',
                    },
                    fr: {
                        singular: 'ville ayant un rang de comitat',
                        plural: '',
                    },
                    hu: {
                        singular: 'megyei jogú város',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                hu: 'Szombathely',
            },
        },
        'HU-SK': {
            numericCode: '348',
            code: 'HU-SK',
            category: {
                id: '245',
                names: {
                    en: {
                        singular: 'city with county rights',
                        plural: 'cities of county right',
                    },
                    fr: {
                        singular: 'ville ayant un rang de comitat',
                        plural: '',
                    },
                    hu: {
                        singular: 'megyei jogú város',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                hu: 'Szolnok',
            },
        },
        'HU-SN': {
            numericCode: '348',
            code: 'HU-SN',
            category: {
                id: '245',
                names: {
                    en: {
                        singular: 'city with county rights',
                        plural: 'cities of county right',
                    },
                    fr: {
                        singular: 'ville ayant un rang de comitat',
                        plural: '',
                    },
                    hu: {
                        singular: 'megyei jogú város',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                hu: 'Sopron',
            },
        },
        'HU-SS': {
            numericCode: '348',
            code: 'HU-SS',
            category: {
                id: '245',
                names: {
                    en: {
                        singular: 'city with county rights',
                        plural: 'cities of county right',
                    },
                    fr: {
                        singular: 'ville ayant un rang de comitat',
                        plural: '',
                    },
                    hu: {
                        singular: 'megyei jogú város',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                hu: 'Szekszárd',
            },
        },
        'HU-ST': {
            numericCode: '348',
            code: 'HU-ST',
            category: {
                id: '245',
                names: {
                    en: {
                        singular: 'city with county rights',
                        plural: 'cities of county right',
                    },
                    fr: {
                        singular: 'ville ayant un rang de comitat',
                        plural: '',
                    },
                    hu: {
                        singular: 'megyei jogú város',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                hu: 'Salgótarján',
            },
        },
        'HU-TB': {
            numericCode: '348',
            code: 'HU-TB',
            category: {
                id: '245',
                names: {
                    en: {
                        singular: 'city with county rights',
                        plural: 'cities of county right',
                    },
                    fr: {
                        singular: 'ville ayant un rang de comitat',
                        plural: '',
                    },
                    hu: {
                        singular: 'megyei jogú város',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                hu: 'Tatabánya',
            },
        },
        'HU-VM': {
            numericCode: '348',
            code: 'HU-VM',
            category: {
                id: '245',
                names: {
                    en: {
                        singular: 'city with county rights',
                        plural: 'cities of county right',
                    },
                    fr: {
                        singular: 'ville ayant un rang de comitat',
                        plural: '',
                    },
                    hu: {
                        singular: 'megyei jogú város',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                hu: 'Veszprém',
            },
        },
        'HU-ZE': {
            numericCode: '348',
            code: 'HU-ZE',
            category: {
                id: '245',
                names: {
                    en: {
                        singular: 'city with county rights',
                        plural: 'cities of county right',
                    },
                    fr: {
                        singular: 'ville ayant un rang de comitat',
                        plural: '',
                    },
                    hu: {
                        singular: 'megyei jogú város',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                hu: 'Zalaegerszeg',
            },
        },
        'HU-BU': {
            numericCode: '348',
            code: 'HU-BU',
            category: {
                id: '406',
                names: {
                    en: {
                        singular: 'capital city',
                        plural: 'capital cities',
                    },
                    fr: {
                        singular: 'ville capitale',
                        plural: '',
                    },
                    hu: {
                        singular: 'főváros',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                hu: 'Budapest',
            },
        },
    },
    cities: [
        {
            name: 'Törökszentmiklós',
            subdivision: 'Jász-Nagykun-Szolnok',
        },
        {
            name: 'Tiszaújváros',
            subdivision: 'Borsod-Abaúj-Zemplén',
        },
        {
            name: 'Szolnok',
            subdivision: 'Jász-Nagykun-Szolnok',
        },
        {
            name: 'Szentes',
            subdivision: 'Csongrád',
        },
        {
            name: 'Szeged',
            subdivision: 'Csongrád',
        },
        {
            name: 'Szarvas',
            subdivision: 'Bekes',
        },
        {
            name: 'Sátoraljaújhely',
            subdivision: 'Borsod-Abaúj-Zemplén',
        },
        {
            name: 'Püspökladány',
            subdivision: 'Hajdú-Bihar',
        },
        {
            name: 'Ózd',
            subdivision: 'Borsod-Abaúj-Zemplén',
        },
        {
            name: 'Orosháza',
            subdivision: 'Bekes',
        },
        {
            name: 'Nyíregyháza',
            subdivision: 'Szabolcs-Szatmár-Bereg',
        },
        {
            name: 'Miskolc',
            subdivision: 'Borsod-Abaúj-Zemplén',
        },
        {
            name: 'Mezőtúr',
            subdivision: 'Jász-Nagykun-Szolnok',
        },
        {
            name: 'Mezőkövesd',
            subdivision: 'Borsod-Abaúj-Zemplén',
        },
        {
            name: 'Mátészalka',
            subdivision: 'Szabolcs-Szatmár-Bereg',
        },
        {
            name: 'Makó',
            subdivision: 'Csongrád',
        },
        {
            name: 'Kisvárda',
            subdivision: 'Szabolcs-Szatmár-Bereg',
        },
        {
            name: 'Kazincbarcika',
            subdivision: 'Borsod-Abaúj-Zemplén',
        },
        {
            name: 'Karcag',
            subdivision: 'Jász-Nagykun-Szolnok',
        },
        {
            name: 'Hódmezővásárhely',
            subdivision: 'Csongrád',
        },
        {
            name: 'Hajdúszoboszló',
            subdivision: 'Hajdú-Bihar',
        },
        {
            name: 'Hajdúnánás',
            subdivision: 'Hajdú-Bihar',
        },
        {
            name: 'Hajdúböszörmény',
            subdivision: 'Hajdú-Bihar',
        },
        {
            name: 'Gyula',
            subdivision: 'Bekes',
        },
        {
            name: 'Gyomaendrőd',
            subdivision: 'Bekes',
        },
        {
            name: 'Eger',
            subdivision: 'Heves',
        },
        {
            name: 'Debrecen',
            subdivision: 'Hajdú-Bihar',
        },
        {
            name: 'Csongrád',
            subdivision: 'Csongrád',
        },
        {
            name: 'Berettyóújfalu',
            subdivision: 'Hajdú-Bihar',
        },
        {
            name: 'Békéscsaba',
            subdivision: 'Bekes',
        },
        {
            name: 'Békés',
            subdivision: 'Bekes',
        },
        {
            name: 'Balmazújváros',
            subdivision: 'Hajdú-Bihar',
        },
        {
            name: 'Abony',
            subdivision: 'Pest',
        },
        {
            name: 'Zalaegerszeg',
            subdivision: 'Zala',
        },
        {
            name: 'Veszprém',
            subdivision: 'Veszprém',
        },
        {
            name: 'Vecsés',
            subdivision: 'Pest',
        },
        {
            name: 'Várpalota',
            subdivision: 'Veszprém',
        },
        {
            name: 'Vác',
            subdivision: 'Pest',
        },
        {
            name: 'Tatabánya',
            subdivision: 'Komárom-Esztergom',
        },
        {
            name: 'Tata',
            subdivision: 'Komárom-Esztergom',
        },
        {
            name: 'Tapolca',
            subdivision: 'Veszprém',
        },
        {
            name: 'Szombathely',
            subdivision: 'Vas',
        },
        {
            name: 'Szigetszentmiklós',
            subdivision: 'Pest',
        },
        {
            name: 'Szentendre',
            subdivision: 'Pest',
        },
        {
            name: 'Szekszárd',
            subdivision: 'Tolna',
        },
        {
            name: 'Székesfehérvár',
            subdivision: 'Fejér',
        },
        {
            name: 'Százhalombatta',
            subdivision: 'Pest',
        },
        {
            name: 'Sopron',
            subdivision: 'Győr-Moson-Sopron',
        },
        {
            name: 'Siófok',
            subdivision: 'Somogy',
        },
        {
            name: 'Sárvár',
            subdivision: 'Vas',
        },
        {
            name: 'Salgótarján',
            subdivision: 'Nógrád',
        },
        {
            name: 'Pécs',
            subdivision: 'Baranya',
        },
        {
            name: 'Parádsasvár',
            subdivision: 'Heves',
        },
        {
            name: 'Pápa',
            subdivision: 'Veszprém',
        },
        {
            name: 'Paks',
            subdivision: 'Tolna',
        },
        {
            name: 'Oroszlány',
            subdivision: 'Komárom-Esztergom',
        },
        {
            name: 'Nagykőrös',
            subdivision: 'Pest',
        },
        {
            name: 'Nagykanizsa',
            subdivision: 'Zala',
        },
        {
            name: 'Mosonmagyaróvár',
            subdivision: 'Győr-Moson-Sopron',
        },
        {
            name: 'Monor',
            subdivision: 'Pest',
        },
        {
            name: 'Mohács',
            subdivision: 'Baranya',
        },
        {
            name: 'Komló',
            subdivision: 'Baranya',
        },
        {
            name: 'Komárom',
            subdivision: 'Komárom-Esztergom',
        },
        {
            name: 'Kiskunhalas',
            subdivision: 'Bács-Kiskun',
        },
        {
            name: 'Kiskunfélegyháza',
            subdivision: 'Bács-Kiskun',
        },
        {
            name: 'Kiskőrös',
            subdivision: 'Bács-Kiskun',
        },
        {
            name: 'Keszthely',
            subdivision: 'Zala',
        },
        {
            name: 'Kecskemét',
            subdivision: 'Bács-Kiskun',
        },
        {
            name: 'Kaposvár',
            subdivision: 'Somogy',
        },
        {
            name: 'Kalocsa',
            subdivision: 'Bács-Kiskun',
        },
        {
            name: 'Jászberény',
            subdivision: 'Jász-Nagykun-Szolnok',
        },
        {
            name: 'Hatvan',
            subdivision: 'Heves',
        },
        {
            name: 'Győr',
            subdivision: 'Győr-Moson-Sopron',
        },
        {
            name: 'Gyöngyös',
            subdivision: 'Heves',
        },
        {
            name: 'Gyál',
            subdivision: 'Pest',
        },
        {
            name: 'Gödöllő',
            subdivision: 'Pest',
        },
        {
            name: 'Göd',
            subdivision: 'Pest',
        },
        {
            name: 'Fót',
            subdivision: 'Pest',
        },
        {
            name: 'Esztergom',
            subdivision: 'Komárom-Esztergom',
        },
        {
            name: 'Érd',
            subdivision: 'Pest',
        },
        {
            name: 'Dunaújváros',
            subdivision: 'Fejér',
        },
        {
            name: 'Dunakeszi',
            subdivision: 'Pest',
        },
        {
            name: 'Dunaharaszti',
            subdivision: 'Pest',
        },
        {
            name: 'Dombóvár',
            subdivision: 'Tolna',
        },
        {
            name: 'Dabas',
            subdivision: 'Pest',
        },
        {
            name: 'Cegléd',
            subdivision: 'Pest',
        },
        {
            name: 'Budapest',
            subdivision: 'Budapest',
        },
        {
            name: 'Budaörs',
            subdivision: 'Pest',
        },
        {
            name: 'Balassagyarmat',
            subdivision: 'Nógrád',
        },
        {
            name: 'Baja',
            subdivision: 'Bács-Kiskun',
        },
        {
            name: 'Ajka',
            subdivision: 'Veszprém',
        },
        {
            name: 'Budapest XII. kerület',
            subdivision: 'Budapest',
        },
        {
            name: 'Budapest XI. kerület',
            subdivision: 'Budapest',
        },
        {
            name: 'Budapest IX. kerület',
            subdivision: 'Budapest',
        },
        {
            name: 'Budapest VIII. kerület',
            subdivision: 'Budapest',
        },
        {
            name: 'Budapest VII. kerület',
            subdivision: 'Budapest',
        },
        {
            name: 'Budapest VI. kerület',
            subdivision: 'Budapest',
        },
        {
            name: 'Budapest XIV. kerület',
            subdivision: 'Budapest',
        },
        {
            name: 'Budapest XIII. kerület',
            subdivision: 'Budapest',
        },
        {
            name: 'Budapest IV. kerület',
            subdivision: 'Budapest',
        },
        {
            name: 'Budapest XV. kerület',
            subdivision: 'Budapest',
        },
        {
            name: 'Budapest XVI. kerület',
            subdivision: 'Budapest',
        },
        {
            name: 'Budapest X. kerület',
            subdivision: 'Budapest',
        },
        {
            name: 'Budapest XIX. kerület',
            subdivision: 'Budapest',
        },
        {
            name: 'Budapest XVIII. kerület',
            subdivision: 'Budapest',
        },
        {
            name: 'Budapest XXIII. kerület',
            subdivision: 'Budapest',
        },
        {
            name: 'Budapest XXII. kerület',
            subdivision: 'Budapest',
        },
        {
            name: 'Budapest XXI. kerület',
            subdivision: 'Budapest',
        },
        {
            name: 'Budapest XX. kerület',
            subdivision: 'Budapest',
        },
        {
            name: 'Budapest XVII. kerület',
            subdivision: 'Budapest',
        },
        {
            name: 'Budapest III. kerület',
            subdivision: 'Budapest',
        },
        {
            name: 'Budapest II. kerület',
            subdivision: 'Budapest',
        },
        {
            name: 'Budapest I. kerület',
            subdivision: 'Budapest',
        },
    ],
};
//# sourceMappingURL=data:application/json;base64,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